import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import { SliderData } from './sliderData';
import {
  HiOutlineArrowNarrowLeft,
  HiOutlineArrowNarrowRight
} from 'react-icons/hi';

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return <HiOutlineArrowNarrowRight className={className} onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return <HiOutlineArrowNarrowLeft className={className} onClick={onClick} />;
}

const InfoSlider = () => {
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '60px',
    slidesToShow: 1,
    speed: 500,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  };
  return (
    <StyledInfoSlider {...settings}>
      {SliderData.map(({ src }, index) => (
        <img key={index} src={src} alt="info" />
      ))}
    </StyledInfoSlider>
  );
};

const StyledInfoSlider = styled(Slider)`
  width: 40%;
  & [aria-hidden='true'] img {
    height: 300px;
  }
  & [aria-hidden='false'] img {
    height: 400px;
  }
  & .slick-track {
    display: flex;
    align-items: center;
  }
  & .slick-arrow {
    top: auto;
    bottom: -34px;
    color: black;
    z-index: 1;
  }
  & .slick-next {
    right: 30%;
  }
  & .slick-prev {
    left: 32%;
  }
  @media (max-width: 1300px) {
    width: 60%;
    padding-top: 50px;
    & [aria-hidden='true'] img {
      height: 100%;
      transform: scale(1, 0.8);
    }
    & [aria-hidden='false'] img {
      height: 100%;
    }
  }
  @media (max-width: 850px) {
    width: 90%;
  }
  @media (max-width: 650px) {
    width: 100%;
    & .slick-next {
      right: 23%;
    }
    & .slick-prev {
      left: 26%;
    }
  }
  @media (max-width: 500px) {
    padding-top: 50px;
    & [aria-hidden='true'] img {
      height: 100%;
    }
    & [aria-hidden='false'] img {
      height: 100%;
    }
    & .slick-next {
      right: 12%;
    }
    & .slick-prev {
      left: 15%;
    }
  }
`;

export default InfoSlider;
